
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import App from './App.vue';
import router from './router';
import { createApp } from 'vue';

import { createPinia } from 'pinia';
const pinia = createPinia();

const atlasDiv = document.getElementById('atlasApp')

if (atlasDiv && atlasDiv.hasAttribute('data-v-app')) {
  console.log('For some reason the app has already been mounted, lets not mount it again');
} else {
  createApp(App).use(router).use(pinia).mount('#atlasApp');
}

